import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getTicketById } from '@/service/ticketService';
import { defineTargetProjectAndPanelWhenOpenTelephoneTicket } from '@/component/notification/handler/NotificationHandler';

/**
 * Open telephone ticket detail + chat panel
 * @param {Object} ticketData - { ticketId, chatThreadId }
 * @param {Object} projectInuseDetail - current project detail
 * @param {Array} projectList - list of projects user belongs to
 * @param {Function} addNewPanel - Recoil setter for panel
 */
export const openTelephoneTicketPanel = async (ticketData, projectInuseDetail, projectList, addNewPanel) => {
    const { ticketId, chatThreadId } = ticketData;
    if (!ticketId) return;

    const ticketDetail = await getTicketById(null, ticketId);
    if (!ticketDetail || Utils.isEmptyObject(ticketDetail)) return;

    const metaData = Utils.convertJSONDataToObject(ticketDetail.metaData);
    const sourceInfo = {
        ticketCallType: metaData?.callType,
        affiliationProject: ticketDetail.affiliationProject,
        customer: ticketDetail.customer,
        projectTarget: Utils.convertJSONDataToObject(ticketDetail.projectTarget) || [],
        ticketType: ticketDetail.ticketType,
    };

    const argsAll = {
        projectInuseDetail,
        projectList,
    };

    const { panelType, projectTargetId } = await defineTargetProjectAndPanelWhenOpenTelephoneTicket(argsAll, sourceInfo);
    if (!panelType || !projectTargetId) return;

    const ticketDetailPanelType = panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST
        ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
        : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;

    const chatThreadPanelType = panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST
        ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
        : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;

    const newPanelId = Date.now().toString();
    addNewPanel({
        type: ticketDetailPanelType,
        tabId: ticketId,
        ticketId: ticketId,
        newPanelId: newPanelId,
    });

    const resolvedChatThreadId = chatThreadId || ticketDetail.chatThreadWithCustomer;
    if (resolvedChatThreadId) {
        setTimeout(() => {
            addNewPanel({
                type: chatThreadPanelType,
                tabId: ticketId,
                ticketId: ticketId,
                currentPanelId: newPanelId,
                selectThreadId: resolvedChatThreadId,
                openRelatePanelType: ticketDetailPanelType,
            });
        }, 500);
    }
};
